import { FamousInvestor } from '../types/dashboard.types';

export const famousInvestors: FamousInvestor[] = [
  {
    name: 'Warren Buffett',
    description: 'Value investing legend focused on long-term fundamental analysis and sustainable competitive advantages',
    traits: {
      macroVsMicro: 15,
      valueVsGrowth: 10,
      timeHorizon: 95,
      passiveVsActive: 52,
      strategicVsFinancial: 25,
    },
    photo: '/buffet.jpg',
  },
  {
    name: 'Peter Thiel',
    description: 'Contrarian tech investor seeking monopolistic advantages and transformative technologies',
    traits: {
      macroVsMicro: 51,
      valueVsGrowth: 85,
      timeHorizon: 86,
      passiveVsActive: 70,
      strategicVsFinancial: 80,
    },
    photo: '/Thiel.jpg',
  },
  {
    name: 'Ray Dalio',
    description: 'Macro-focused systematic investor using principles-based approach and radical transparency',
    traits: {
      macroVsMicro: 90,
      valueVsGrowth: 50,
      timeHorizon: 85,
      passiveVsActive: 60,
      strategicVsFinancial: 65,
    },
    photo: '/RayDalio_2017-stageshot.jpg',
  },
  {
    name: 'Masayoshi Son',
    description: 'Visionary technology investor taking bold asymmetric bets on future paradigm shifts',
    traits: {
      macroVsMicro: 70,
      valueVsGrowth: 95,
      timeHorizon: 90,
      passiveVsActive: 85,
      strategicVsFinancial: 90,
    },
    photo: '/Masayoshi.webp',
  },
];

export const ceo =
  {
    name: 'Dilhan Pillay Sandrasegara',
    role: 'Executive Director & Chief Executive Officer',
    shortName: 'Dilhan',
    traits: {
      macroVsMicro: 65,
      valueVsGrowth: 55,
      timeHorizon: 70,
      passiveVsActive: 90,
      strategicVsFinancial: 75,
    },
    photo: '/Dilhan.jpeg',
  }
